/**
 * WordPress dependencies
 */

import { InnerBlocks } from '@wordpress/block-editor'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

/**
 * External dependencies
 */
import classnames from 'classnames'
import { applyFilters } from '@wordpress/hooks'
import { withUniqueClass } from '~cartzillagb/higher-order'

const save = props => {
	const {
		className,
		lgColumns,
		mdColumns,
		smColumns,
		columnId,
		backgroundImage,
		height,
	} = props.attributes

	const mainClasses = classnames( [
		'column',
		className,
		'czgb-single-column',
		`col-sm-${ smColumns } col-md-${ mdColumns } col-lg-${ lgColumns } order-md-${props.attributes.order}`
	], applyFilters( 'cartzillagb.column.main-block.classes', {}, props ) )

	const htmlAttr = {}

	if( columnId !== '' ) {
		htmlAttr.id = columnId
	}

	if( backgroundImage) {
		htmlAttr.style = {
			backgroundImage: "url(" + ( backgroundImage ) + ")",
			minHeight: `${ height }rem`,
		}
	}

	return (
		<Fragment>
			<div className={ mainClasses } { ...htmlAttr }>
				<InnerBlocks.Content />
			</div>
		</Fragment>
	)
}

export default compose(
	withUniqueClass,
)( save )